import Vue from 'vue'
import Router, {RawLocation, Route} from 'vue-router'

import Landing from '@/views/general/Landing.vue'
import TestPage from '@/valchrom/common/metadata/TestPage.vue'

import Dashboard from '@/views/general/Dashboard.vue'
import About from '@/views/general/About.vue'
import Help from '@/views/general/Help.vue'
import Contact from '@/views/general/Contact.vue'
// User
import Signup from '@/views/user/Signup.vue'
import Login from '@/views/user/Login.vue'
import Account from '@/views/user/Account.vue'
import PasswordReset from '@/views/user/PasswordReset.vue'

// Method
import Methods from '@/views/method/Methods.vue'
import EditMethod from '@/views/method/EditMethod.vue'
import ViewMethod from '@/views/method/ViewMethod.vue'
import NewMethod from '@/views/method/NewMethod.vue'
// Overview
import Overview from '@/views/overview/Overview.vue'

// Template
import ValidationPlanTemplates from '@/views/template/ValidationPlanTemplates.vue'
import NewValidationPlanTemplate from '@/views/template/NewValidationPlanTemplate.vue'
import EditValidationPlanTemplate from '@/views/template/EditValidationPlanTemplate.vue'
import ViewValidationPlanTemplate from '@/views/template/ViewValidationPlanTemplate.vue'
// Plans
import ExperimentalPlans from '@/views/plan/ExperimentalPlans.vue'
import EditExperimentalPlan from '@/views/plan/EditExperimentalPlan.vue'
import ViewExperimentalPlan from '@/views/plan/ViewExperimentalPlan.vue'
import NewExperimentalPlan from '@/views/plan/NewExperimentalPlan.vue'
// Dataset
import ViewAllExperimentalDatasets from '@/views/dataset/ViewAllExperimentalDatasets.vue'
import ViewAnExperimentalDataset from '@/views/dataset/ViewAnExperimentalDataset.vue'
import EditExperimentalDataset from '@/views/dataset/EditExperimentalDataset.vue'
import ViewExperimentalDatasetsByPlan from '@/views/dataset/ViewExperimentalDatasetsByPlan.vue'
import NewExperimentalDataset from '@/views/dataset/NewExperimentalDataset.vue'
import UploadExperimentalDataset from '@/views/dataset/UploadExperimentalDataset.vue'
import ViewExperimentalData from '@/views/dataset/ViewExperimentalData.vue'

// Store
import store from '@/store'
import DatasetOverview from './valchrom/views/dataset/DatasetOverview.vue';
import ReportView from "@/valchrom/views/dataset/ReportView.vue";
import ListReportsView from './valchrom/views/report/ListReportsView.vue';
import EditReportView from "@/valchrom/views/report/EditReportView.vue";
import NewReportView from "@/valchrom/views/report/NewReportView.vue";
import ViewDataset from "@/valchrom/views/mathservice/dataset/ViewDataset.vue";
import ViewInput from "@/valchrom/views/mathservice/dataset/ViewInput.vue";
import NewOverview from "@/valchrom/views/mathservice/dataset/overview/NewOverview.vue";


Vue.use(Router)

const requireAuth = (to: Route,
                     from: Route,
                     next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) => {
  if (!store.getters.authenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

const afterAuth = (to: Route,
                   from: Route,
                   next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) => {
  if (store.getters.authenticated) {
    next(from.path);
  } else {
    next();
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      meta: {
        breadcrumb: [
        ]
      }
    },
         {
      path: '/testbed',
      name: 'TestPage',
      component: TestPage,
      meta: {
        breadcrumb: [
             { name: 'Test' }

        ]
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'Sign Up' },  
        ]
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: afterAuth,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'Login' },  
        ]
      }
    },
    {
      path: '/login/:activation_code',
      name: 'Login',
      component: Login,
      beforeEnter: afterAuth,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'Login' },
        ]
      }
    },
    {
      path: '/password-reset/:uid/:token',
      name: 'PasswordReset',
      component: PasswordReset,
      props: true,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'PasswordReset' },  
        ]
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'Account' },  
        ]
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard' }  
        ]
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        breadcrumb: [
           { name: 'Home', link: '/'  },
           { name: 'About' },  
        ]
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        breadcrumb: [
          { name: 'Home', link: '/'  },
          { name: 'Help' },
        ]
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        breadcrumb: [
           { name: 'Home', link: '/' },
           { name: 'Contact' },  
        ]
      }
    },
    {
      path: '/methods',
      name: 'Methods',
      component: Methods,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Methods' },  
        ]
      }
    },
    {
      path: '/new-method',
      name: 'NewMethod',
      component: NewMethod,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Methods', link: '/methods' },
           { name: 'New Method' }  
        ]
      }
    },
    {
      path: '/edit-method',
      name: 'EditMethod',
      component: EditMethod,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Methods', link: '/methods' },
           { name: 'Edit Method' }  
        ]
      }
    },
    {
      path: '/view-method',
      name: 'ViewMethod',
      component: ViewMethod,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Methods', link: '/methods' },
           { name: 'View Method' },  
        ]
      }
    },
    {
      path: '/validation-plan-templates',
      name: 'ValidationPlanTemplates',
      component: ValidationPlanTemplates,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Validation Plans' },
        ]
      }
    },
    {
      path: '/new-validation-plan-template',
      name: 'NewValidationPlanTemplate',
      component: NewValidationPlanTemplate,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Validation Plans', link: '/validation-plan-templates' },
           { name: 'New Validation Plan' }
        ]
      }
    },
    {
      path: '/view-validation-plan-template',
      name: 'ViewValidationPlanTemplate',
      component: ViewValidationPlanTemplate,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Validation Plans', link: '/validation-plan-templates' },
           { name: 'View Validation Plan' }
        ]
      }
    },
    {
      path: '/edit-validation-plan-template',
      name: 'EditValidationPlanTemplate',
      component: EditValidationPlanTemplate,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Validation Plans', link: '/validation-plan-templates' },
           { name: 'Edit Validation Plan' }
        ]
      }
    },
    {
      path: '/new-experimental-plan',
      name: 'NewExperimentalPlan',
      component: NewExperimentalPlan,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Plans', link: '/experimental-plans' },
           { name: 'New Experimental Plan' }  
        ]
      }
    },
    {
      path: '/view-experimental-plan',
      name: 'ViewExperimentalPlan',
      component: ViewExperimentalPlan,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Plans', link: '/experimental-plans' },
           { name: 'View Experimental Plan' }  
        ]
      }
    },
    {
      path: '/edit-experimental-plan',
      name: 'EditExperimentalPlan',
      component: EditExperimentalPlan,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Plans', link: '/experimental-plans' },
           { name: 'Edit Experimental Plan' }  
        ]
      }
    },
    {
      path: '/experimental-plans',
      name: 'ExperimentalPlans',
      component: ExperimentalPlans,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Plans' },
        ]
      }
    },
    {
      path: '/view-all-experimental-datasets',
      name: 'ViewAllExperimentalDatasets',
      component: ViewAllExperimentalDatasets,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets' }  
        ]
      }
    },
    {
      path: '/datasets/:id/upload',
      name: 'UploadExperimentalDataset',
      component: UploadExperimentalDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
           { name: 'Upload Experimental Dataset' }  
        ]
      }
    },
    {
      path: '/new-experimental-dataset',
      name: 'NewExperimentalDataset',
      component: NewExperimentalDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
           { name: 'New Experimental Dataset' }  
        ]
      }
    },
    {
      path: '/view-an-experimental-dataset',
      name: 'ViewAnExperimentalDataset',
      component: ViewAnExperimentalDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
           { name: 'View Experimental Dataset' }  
        ]
      }
    },
      // math service related stuff
    {
      path: '/view-dataset/:id',
      name: 'ViewDataset',
      component: ViewDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'View Experimental Dataset' }
        ]
      }
    },
    {
      path: '/view-dataset',
      name: 'ViewDataset',
      component: ViewDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'View Experimental Dataset' }
        ]
      }
    },
    {
      path: '/dataset/:dataset_id/input/:am_name',
      name: 'ViewInput',
      component: ViewInput,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'View Experimental Dataset', link: '/view-dataset'  },
          { name: 'View Input' }
        ]
      }
    },
    {
      path: '/dataset/:dataset_id/overview',
      name: 'NewOverview',
      component: NewOverview,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'View Experimental Dataset', link: '/view-dataset'  },
          { name: 'Overview' }
        ]
      }
    },
    //end of math service related stuff
    {
      path: '/view-experimental-datasets-by-plan',
      name: 'ViewExperimentalDatasetsByPlan',
      component: ViewExperimentalDatasetsByPlan,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Plans', link: '/experimental-plans' },
           { name: 'View Experimental Datasets' }  
        ]
      }
    },
    {
      path: '/edit-experimental-dataset',
      name: 'EditExperimentalDataset',
      component: EditExperimentalDataset,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
           { name: 'Edit Experimental Dataset' }  
        ]
      }
    },

    {
      path: '/view-experimental-data',
      name: 'ViewExperimentalData',
      component: ViewExperimentalData,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
           { name: 'Dashboard', link: '/dashboard' },
           { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
           { name: 'View Experimental Dataset', link: '/view-an-experimental-dataset' },
           { name: 'View Experimental Data'}  
        ]
      }
    },

    //NEW Overview
    {
      path: '/datasets/:datasetId/overview',
      name: 'DatasetOverview',
      component: DatasetOverview,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'Overview' }
        ]
      }
    },
    //developmenr tool - wysiwyg editor report
    {
      path: '/datasets/:datasetId/report',
      name: 'ReportView',
      component: ReportView,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Experimental Datasets', link: '/view-all-experimental-datasets' },
          { name: 'Report' }
        ]
      }
    },
    {
      path: '/reports/:id',
      name: 'EditReportView',
      component: EditReportView,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Reports', link: '/reports' },
          { name: 'Edit Report' }
        ]
      }
    },
    {
      path: '/new-report',
      name: 'NewReportView',
      component: NewReportView,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Reports', link: '/reports' },
          { name: 'New Report' }
        ]
      }
    },
    {
      path: '/reports',
      name: 'ListReportsView',
      component: ListReportsView,
      beforeEnter: requireAuth,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Reports'}
        ]
      }
    },


  ]
})
